import type { BandName, MeterConfig } from '../engine/types';

const ORDER: BandName[] = ['cold', 'cool', 'neutral', 'warm', 'hot'];
const LABEL: Record<BandName, string> = {
  cold: 'Cold', cool: 'Cool', neutral: 'Neutral', warm: 'Warm', hot: 'Hot',
};

/**
 * §10.4 / §19 — a horizontal band indicator with a labeled marker, top-right.
 *
 * Never a number. The rep is reading a person, not a score, and a numeral would
 * invite them to optimize it. The marker transitions rather than jumping,
 * because the movement arrives with the prospect's reply (§10.4).
 */
export function SentimentMeter({
  value, band, meter, hidden,
}: {
  value: number;
  band: BandName;
  meter: MeterConfig;
  /** Hidden entirely in summative mode (§10.4, §14.4). */
  hidden?: boolean;
}) {
  if (hidden) return null;

  return (
    <div className="meter" role="img" aria-label={`The prospect sounds ${LABEL[band].toLowerCase()}`}>
      <div className="meter-track">
        {ORDER.map((name) => {
          const [lo, hi] = meter.bands[name];
          return (
            <span
              key={name}
              className={`meter-band meter-${name} ${band === name ? 'active' : ''}`}
              style={{ flexGrow: hi - lo + 1 }}
            />
          );
        })}
        <span className="meter-marker" style={{ left: `${value}%` }} aria-hidden="true" />
      </div>
      <span className={`meter-label meter-text-${band}`}>{LABEL[band]}</span>
    </div>
  );
}
